import * as Sentry from "@sentry/browser";

Sentry.init({
    dsn: "https://c622b5edfcb2bc5d84e2b12c10d32673@o90622.ingest.us.sentry.io/4507905586429952",
    integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration(),
    ],
    tracesSampleRate: 1.0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    beforeSend(event, hint) {
        const error = hint.originalException;

        // Ignore Alpine.js "selection is not defined" error from order list template
        if (error && error.message && error.message.includes('selection is not defined')) {
            return null;
        }

        return event;
    },
});
